export const messages = {
  ar: {
    // SIDEBAR
    // Mi Perfil
    perfil: "Mi Perfil",
    datos: "Mis Datos",
    cambiarContraseña: "Cambiar Contraseña",
    cerrarSesion: "Cerrar Sesión",
    // Mensajes
    bandeja: "Bandeja de Entrada",
    menEnviados: "Enviados",
    //
    mensajes: "Mensajes",
    panel: "Panel",
    manual: "Manual CRM",
    biblioteca: "Biblioteca",
    // Empresas
    empresas: "Empresas",
    despachos: "Despachos",
    usuarios: "Usuarios",
    asociaciones: "Asociaciones",
    grupos: "Grupos",
    zonas: "Zonas",
    plantilla: `Plantillas Email Notificaciones`,

    contactos: "Contactos",
    clientes: "Clientes",
    videoconferencia: "Videoconferencia",
    expedientes: "Expedientes",
    notificaciones: "Notificaciones CRM",
    facturas: "Facturas",
    // Informes
    informes: "Informes",
    informeGeneral: "Informe General",
    informeUsuario: "Informe por Usuario",
    informeLlamadas: "Informe Llamadas",
    //
    // Configuracion
    configuracion: "Configuración",
    tiposDeUsuarios: "Tipos de Usuarios",
    hojasDeCargo: "Hojas de Encargo",
    registroHojas: "Registro de Hojas de Encargo",
    tiposCasos: "Tipos de Casos",
    //
    title: "رياكت پرو سايد بار",
    sidebarTitle: "پرو سايد بار",
    description:
      "شريط جانبي مع قوائم منسدلة وعدد غير محدود من القوائم الفرعية المتداخلة",
    dashboard: "لوحة القيادة",
    components: "مكونات",
    dropdown: "اسقاط",
    submenu: "قائمة فرعية",
    multiLevel: "متعدد المستويات",
    collapsed: "انطوى",
    rtl: "ر ت ل",
    image: "صورة الخلفية",
    new: "جديد",
    withPrefix: "مع البادئة",
    withSuffix: "مع اللاحقة",
    viewSource: "عرض الكود",
  },
  en: {
    // SIDEBAR
    // Mi Perfil
    perfil: "Mi Perfil",
    datos: "Mis Datos",
    cambiarContraseña: "Cambiar Contraseña",
    cerrarSesion: "Cerrar Sesión",
    // Mensajes
    bandeja: "Bandeja de Entrada",
    menEnviados: "Enviados",
    //
    mensajes: "Mensajes",
    panel: "Panel",
    manual: "Manual CRM",
    biblioteca: "Biblioteca",
    // Empresas
    empresas: "Empresas",
    despachos: "Despachos",
    usuarios: "Usuarios",
    asociaciones: "Asociaciones",
    grupos: "Grupos",
    zonas: "Zonas",
    plantilla: `Plantillas Email 
                Notificaciones`,
    //
    contactos: "Contactos",
    clientes: "Clientes",
    videoconferencia: "Videoconferencia",
    expedientes: "Expedientes",
    notificaciones: "Notificaciones CRM",
    facturas: "Facturas",
    // Informes
    informes: "Informes",
    informeGeneral: "Informe General",
    informeUsuario: "Informe por Usuario",
    informeLlamadas: "Informe Llamadas",
    //
    // Configuracion
    configuracion: "Configuración",
    tiposDeUsuarios: "Tipos de Usuarios",
    hojasDeCargo: "Hojas de Encargo",
    registroHojas: "Registro de Hojas de Encargo",
    tiposCasos: "Tipos de Casos",
    //
    title: "React Pro Sidebar",
    sidebarTitle: "Pro Sidebar",
    description:
      "React sidebar library with dropdown menus and unlimited number of nested submenus",
    dashboard: "Dashboard",
    components: "Components",
    dropdown: "Dropdown",
    submenu: "Submenu",
    multiLevel: "Multi Level",
    collapsed: "Collapsed",
    rtl: "RTL",
    image: "Background image",
    new: "NEW",
    withPrefix: "With Prefix",
    withSuffix: "With Suffix",
    viewSource: "View Source",
  },
  es: {
    // SIDEBAR
    // Mi Perfil
    perfil: "Mi Perfil",
    datos: "Mis Datos",
    cambiarContraseña: "Cambiar Contraseña",
    cerrarSesion: "Cerrar Sesión",
    // Mensajes
    bandeja: "Bandeja de Entrada",
    menEnviados: "Enviados",
    //
    mensajes: "Mensajes",
    panel: "Panel",
    manual: "Manual CRM",
    biblioteca: "Biblioteca",
    // Empresas
    empresas: "Empresas",
    despachos: "Despachos",
    usuarios: "Usuarios CRM",
    asociaciones: "Asociaciones",
    grupos: "Grupos",
    zonas: "Zonas",
    plantilla: "Plantillas Email",
    //
    contactos: "Contactos",
    clientes: "Clientes",
    videoconferencia: "Videoconferencia",
    expedientes: "Expedientes",
    notificaciones: "Notificaciones CRM",
    facturas: "Facturas",
    // Informes
    informes: "Informes",
    informeGeneral: "Informe General",
    informeUsuario: "Informe por Usuario",
    informeLlamadas: "Informe Llamadas",
    //
    // Configuracion
    configuracion: "Configuración",
    tiposDeUsuarios: "Roles de usuario",
    hojasDeCargo: "Hojas de encargo",
    registroHojas: "Registro de hojas de encargo",
    expedientesConfig: "Configuración expediente",
    tiposCasos: "Tipos de casos",
    // BODY
    title: "React Pro Sidebar",
    sidebarTitle: "Pro Sidebar",
    description:
      "React sidebar library with dropdown menus and unlimited number of nested submenus",
    dashboard: "Dashboard",
    components: "Components",
    dropdown: "Dropdown",
    submenu: "Submenu",
    multiLevel: "Multi Level",
    collapsed: "Collapsed",
    rtl: "RTL",
    image: "Background image",
    new: "NEW",
    withPrefix: "With Prefix",
    withSuffix: "With Suffix",
    viewSource: "View Source",
  },
};
